<template>
  <div class="subView">

    <div class="subView_list">
      <div class="subView_item">
        <div class="title">
          <span class="text" style="margin-left: 10px">
                    {{navList.name}}</span>
        </div>
        <div class="btnBox">
          <el-button class="btn" @click="goabout()">免费咨询</el-button>
        </div>
      </div>
      <!--            <div class="box-left">-->
      <!--                <saasNav></saasNav>-->
      <!--            </div>-->
      <div class="box-right">
        <div class="subView_top">

          <div class="top-title">
            <p class="title">概述</p>
            <div class="border"></div>
          </div>
          <div class="" v-if="navList.overview">
            <p style="line-height: 30px" v-html="navList.overview"></p>
          </div>
          <div class="" v-if="navList.overviewImg"
               v-for="(item,index) of navList.overviewImg"
               :key="index"
               style="margin-top: 39px;text-align: center">
            <img :src="item" width="80%" alt="">
          </div>
          <div class="top-title">
            <p class="title">产品介绍</p>
            <div class="border"></div>
          </div>
          <div class="" v-if="navList.productIntroductionText">
            <p style="line-height: 30px">{{navList.productIntroductionText}}</p>
          </div>
          <div v-if="navList.productIntroductionImg"
               style="padding: 20px;text-align: center"
               v-for="(item,index) of navList.productIntroductionImg" :key="index">
            <img :src="item" style="max-width: 100%" alt="">
          </div>
          <div class="" style="margin-top: 20px">
            <div :span="24" v-for="(item3,index) in navList.productIntroduction" :key="index">
              <div class="top-title">
                <p class="title">{{item3.title}}</p>
                <div class="border"></div>
              </div>
              <p style="line-height: 30px">  {{item3.text}}</p>
              <div class="item_img" style="padding: 30px;text-align: center"
                   v-for="(item,index) of item3.img"
                   :key="index"
              >
                <img class="img-tp" :src="item" style="max-width: 100%" alt="">
              </div>
            </div>
          </div>
          <div class="" v-if="navList.productIntroductionText2">
            <p style="line-height: 30px" v-html="navList.productIntroductionText2"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import saasNav from '../mtevidence/saas-nav.vue'
export default {
  name: "mtevidence",
  components:{saasNav},
  data(){
    return{
      navList:{},
      newsList: [
        {
          name: '可信数据空间产品系列',
          overview: '兆信系列产品是湖南宸瀚科技有限公司自主研发的下一代数据智能治理平台，聚焦数据“抗毁性传输”与“隐私保护”双重需求，首创“区块链存证+联邦学习+零信任动态验证”三位一体技术架构。平台以国密算法为安全基底，覆盖数据全生命周期（采集、存储、流通、销毁），攻克跨域指令抗毁传输、多源异构数据融合滞后、信息内部安全等核心难题。',
          productIntroduction: [
            {
              title: '兆隐-国产区块链多方安全隐私计算联邦学习平台：',
              text: '面对数据要素市场化进程中跨机构协作的隐私泄露与效率瓶颈，兆隐平台以“区块链+联邦学习”融合架构为核心，构建安全的数据协同基础设施。通过国产化区块链底层实现数据全生命周期存证与抗毁传输，指令与模型参数经国密算法（SM2/SM3/SM4）加密后分布式上链，单点失效不影响全局传输，抗毁性提升80%。联邦学习框架支持横向（样本异构）、纵向（特征异构）及迁移学习模式，在不暴露原始数据的前提下识别模型，通过自适应梯度裁剪与动态噪声注入技术平衡模型精度与隐私强度，使目标识别准确率提升35%的同时，满足差分隐私（ε≤2）的合规要求。平台内置联合研究预置模板，支持边缘节点轻量化部署，模型训练效率较传统方案提升50%，为全域态势感知提供实时AI赋能。'
            },
            {
              title: '兆易-数据隐私计算交易平台：',
              text: '针对数据资产化流通中的权属争议与跨境合规风险，兆易平台深度融合区块链、隐私计算与零信任技术，构建“数据可用不可见+可信流通”的一体化交易基座。在跨境协作、多国联演等场景中，敏感数据需在主权可控前提下实现价值释放。平台通过智能合约自动化执行数据确权与收益分配，支持数据NFT化流通，企业可将脱敏后的性能参数封装为数字资产，境外合作方通过TEE（可信执行环境）节点进行密态计算，原始数据全程不出域。联邦学习框架集成同态加密与多方安全计算（MPC），模型训练时数据提供方、算法方、算力方贡献度实时上链存证，收益按智能合约自动分配，协作摩擦成本降低60%。同时，平台通过零信任动态验证机制，对跨境访问行为进行实时风险评估（如IP地理位置、设备指纹），异常操作自动触发数据沙箱隔离，防御供应链渗透攻击，满足《数据安全管理办法》等跨境数据主权管控要求。',
              img: [require('@/views/pc/productImg/img1.png')]
            },
            {
              title: '兆零-零信任基础平台及统一认证门户：',
              text: '零信任平台及门户以“动态身份验证+微隔离”为核心，重构数据及全链路安全体系。在涉及数百家单位的复杂协作场景中，传统静态密码认证与粗放权限管理易导致关键敏感信息数据泄露。MTrust整合多因子认证（MFA）、生物识别与设备指纹技术，构建覆盖全流程的统一身份库。各参与方访问设计敏感信息数据时，系统实时评估访问终端安全状态（如固件版本、地理位置），动态授予最小化字段级权限：各参与方仅能访问自身具备权限和需要访问的最小数据集，对其他关键核心数据进行访问将触发虹膜二次认证进行授权后访问。采用零信任网络访问（ZTNA）技术，将数据全生命周期划分为多个微隔离域，阻断横向渗透攻击。敏感数据传输采用国密算法加密，结合区块链存证实现操作日志不可篡改，异常下载行为自动触发沙箱录屏审计，数据泄露溯源效率提升90%。平台深度适配国产化环境，满足敏感数据全生命周期可信管控。',
              img: [require('@/views/pc/productImg/img2.png')]
            },
          ]
        },
        {
          name: '国产自主可控联盟链基础设施产品',
          overview: '兆链系列产品采用自主设计研发的基于DAG的分层分片Gossip高效共识机制、中继链技术、高级智能合约、国密算法及抗量子攻击算法、可监管隐私保护等区块链创新技术，通过边端软硬件一体化智能设备及模组、数据中台软硬一体联盟链服务平台，实现区块链身份标识生成、数据上链存证、链上数据模型构建、链上数据分析、数据同步规则管控、区块链账本、共识机制、加密算法、智能合约等功能，提供数据保障、数据协同、数据管控等服务，包括边端数据到数据中台到用户的全生命周期数据安全、可信、可追溯、抗摧毁、备份恢复、交叉验证、价值评估等能力。能够解决区块链平台性能较弱、稳定性不够、安全功能欠缺等实用化程度低的问题。平台TPS突破10万，处于业内领先，完成了与PK、鲲鹏的国产化适配，可为各领域区块链系统提供平台级支撑。',
          productIntroductionText: '产品主要包括由边缘层设备、底层技术平台、产品和应用平台、案例和解决方案。',
          productIntroductionImg: [require('@/views/pc/productImg/img3.png')],
          productIntroduction: [
            {
              title: '国产高性能自主可控联盟链MT：',
              text: '采用自主设计研发的基于DAG的分层分片Gossip高效共识机制、中继链技术、高级智能合约、国密算法及抗量子攻击算法、可监管隐私保护等区块链创新技术，解决区块链平台性能较弱、稳定性不够、安全功能欠缺等实用化程度低的问题。平台TPS突破10万，处于业内领先，完成了与PK、鲲鹏的国产化适配，可为各领域区块链系统提供平台级支撑。',
              img: [require('@/views/pc/productImg/img4.png')]
            },
            {
              title: '国产联盟链BaaS平台MTBaaS',
              text: '平台将MT区块链平台技术融合云服务，能够为中小企业、个人客户提供在线联盟链应用开发平台服务。MTBaaS支持多链的区块链服务平台，衔接底层链 (IaaS层) 和应用(SaaS层)，具备多类型区块链基础平台动态接入、区块链资源动态分配、按需组建联盟链、将底层链各类功能封装后为应用提供各类区块链功能接口、节点管理、链管理、节点和链的动态监控、业务过滤监管等功能。',
              img: [require('@/views/pc/productImg/img5.png')]
            },
            {
              title: '国产区块链一体机MTServer：',
              text: '区块链一体机提供链网融合、多底链兼容的区块链运行环境，支持区块链节点运行、区块链网络搭建和运维、区块链应用开发，用于快速部署链节点软件（全节点、局部全节点、认证节点、监督节点、共识节点等）和Baas（区块链即服务）管理平台。通过区块链支撑环境软件，为多种异构底链提供虚拟化部署环境、统一的链管理功能。通过配置加速卡、物理密码设备、IC钥匙，支持国密算法和国密证书运用，提高合约并行执行效率，并提供安全接入验证能力。',
              img: [require('@/views/pc/productImg/img6.png')]
            },
            {
              title: '区块链智能终端I型MTIoTI：',
              text: '区块链智能终端MTIoT I型提供MTIoTI-400V2.0、MTIoTI-450V2.0两个版本。MTIoTI-400V2.0屏幕大小支持多版本定制7-16寸，具备业务子链节点功能，支持部署子链节点，支持智能合约定义、部署，支持国密算法。可部署于边端大型企业实现可信数据采集、监测等。MTIoTI-450V2.0尺寸大小为1U，具备业务子链节点功能，支持部署子链节点，支持智能合约定义、部署，支持国密算法。可部署于数据中心机房边端设备数据的可信接入。',
              img: [require('@/views/pc/productImg/img7.png'),require('@/views/pc/productImg/img8.png')]
            },
            {
              title: '区块链智能终端II型MTIoTII：',
              text: 'MT-Ⅱ-300系列区块链智能终端主要部署于分布式能源电站、中小工商户、居民用户台区等场景，从各类智能边缘设备、系统获取业务数据。具备轻节点智能合约执行、接入认证、安全防护等功能，支持碳排计算、减排计算智能合约，按照区块链可信认证机制，进行区域级用户碳排、节能、绿电上网、绿电使用、绿电调控数据上链（计算、交易、记录）与认证。',
              img: [require('@/views/pc/productImg/img9.png')]
            },
            {
              title: '区块链腕表MTWatch：',
              text: '区块链腕表设备支持Micro-USB或USB-C电源接口，常态化工作条件下续航时间不小于8小时。MTWatch以腕表作为区块链轻量化节点，使用定制精简版嵌入式Linux操作系统，集成MT的部分功能，支持国家密码管理部门发布的SM2、SM3、SM4等国密算法，能够实现腕表数据上链存储，提升腕表数据在恶劣的自然环境和复杂的网络环境下防丢失、篡改与仿冒的能力以及容灾抗毁能力。',
              img: [require('@/views/pc/productImg/img10.png')]
            },
            {
              title: '区块链摄像头MTCam：',
              text: '区块链网络摄像头节点自身的算法执行能力，能够对视频关键帧进行提取和分析，并将处理结果、源文件、认证用哈希水印回传至MT链，同时采用合约机制对请求数据进行自动验证及指令回传。MTCam作为轻量化客户端节点，搭载MT区块链轻量化客户端，连接到MT区块链轻量化节点，以服务请求方式获取区块链的相关服务，实现数据上链。同时，支持访问链下存储网络，完成采集数据的链上链下混合存储。',
              img: [require('@/views/pc/productImg/img11.png')]
            },
            {
              title: '国产区块链高可信分布式存储软件StorNet：',
              text: '能够提供ToB的存储服务接口和To C的存储服务应用，并可定制化修改后ToB进行私有化部署。功能包括创建和执行存储智能合约、存储证明、高效共识、多重签名、提供服务的激励、纠删码（Reed-Solomn编码）。StorNet为B端用户提供高性价比企业级的分布式存储解决方案，为C端用户提供具有持久化数据存储能力、良好隐私保护特性和容错能力的个人数据存储服务。',
              img: []
            },
            {
              title: '区块链存储设备HashStor：',
              text: '针对区块链数据存储需求量身定制了专业级机箱、CPU和主板，专门研发的WEB配置管理系统让设备的使用与管理更加简单和方便。',
              img: [require('@/views/pc/productImg/img12.png')]
            },
            {
              title: '区块链数字资产协同创作共享平台：',
              text: '平台基于MT链的数字藏品技术协议发行，在MT链上具有唯一标识，且不可篡改。平台上的数字藏品业务采用用户全流程实名、内容全链路审查。MTNFT平台保证数字资产的唯一性和真实性，通过区块链技术解决数字资产的确权问题，促进数字藏品的交易和价值发现。',
              img: [require('@/views/pc/productImg/img13.png')]
            },
            {
              title: '区块链电子证据存证平台：',
              text: '采用DAG（有向无环图）结构，具有比传统链式结构更高的性能和安全性。可为电子数据提供可信电子凭证、确保存证数据的唯一性、进行7x24h全网监测、支持在线出具公证书和司法鉴定意见书及法律咨询等服务。',
              img: [require('@/views/pc/productImg/img14.png')]
            },
            {
              title: '区块链供应链金融平台：',
              text: '平台以区块链、大数据为核心，依托核心企业的信用及支持，对接多渠道资金，为中小企业解决融资难、融资贵问题。基于“N+N+N模式”即“多家核心企业+多家供应商+多家银行”，平台业务功能包括：（1）保理融资；（2）风控处理；（3）CFCA电子签章；（4）银信开立、拆分、流转、结算。平台业务实体包括：供应商、核心企业、资金方等，以及外围的保理公司、CFCA、会计师事务所、律所等。',
              img: [require('@/views/pc/productImg/img15.png')]
            },
            {
              title: '区块链教学实训平台：',
              text: '为各类学习区块链的用户提供一站式教学实训服务。平台集知名区块链技术、行业案例、模拟仿真于一体，面向全国各大高校、各类培训机构区块链教学实践环节。该平台适用于技术类教学、金融类教学、监管类教学、数字化资产类教学场景。',
              img: [require('@/views/pc/productImg/img16.png')]
            },
          ],
        },
        {
          name: '空天地海潜一体柔性复合防御无人值守集群平台',
          overview: '兆感:空天地海潜一体柔性复合防御无人值守集群平台系统为一套软硬结合的智能感知系统，产品整体设计精巧、使用便捷、稳定可靠，在各领域有着广阔的应用前景。系统通过人工、布撒器等方式将具有感知能力、计算能力和通信能力的微型传感器随机密集布设在需要监控、管制的地域上，以短距低速通信方式迅速组成分簇、网状、树型等多种网络拓扑，推举的簇头通过单跳或多跳路由与隐蔽的汇聚节点相连，并通过中继器、无人机或卫星等方式接入数据综合分析处理云平台，对人、车等运动目标实施无人值守的昼夜监视，进行检测、识别、分类、定位和跟踪。空天地海潜一体柔性复合防御无人值守集群平台可进行地面数据采集、低空空中防御以及海港协防。',
          overviewImg: [require('@/views/pc/productImg/img17.png')],
          productIntroduction: [
            {
              title: '震动传感器：',
              text: '通过运动目标产生的地振动信号识别人、车等多种目标，识别人员行走、挖掘或车辆通过等事件，设备自带无线通信与定位模块，可将探测信息通过网关实时传回后端。',
              img: [require('@/views/pc/productImg/img18.png')]
            },
            {
              title: '声音传感器：：',
              text: '声音阵列传感器用于对布设地域的声音信号进行定位识别，设备自带无线通信、定位及电源模块，可通过网关将探测信息实时传回后端。',
              img: [require('@/views/pc/productImg/img19.png')]
            },
            {
              title: '重载云台：',
              text: '用于需要高稳定性和高负载能力的应用场景。重载云台的主要特点包括高承载能力、高精度、高可靠性和适应恶劣环境的能力。',
              img: [require('@/views/pc/productImg/img20.png')]
            },
            {
              title: '低慢小雷达：',
              text: '低空监视雷达主要应用在复杂的地杂波环境和各种气象条件下，全天候承担对“低慢小”目标进行探测、跟踪和分类识别，提供目标的距离、方位、仰角、速度和属性等信息，为低空空域监视和管理提供有效的信息支援。',
              img: [require('@/views/pc/productImg/img21.png')]
            },
            {
              title: '全向反制系统基站：',
              text: '定向反制系统是针对民用消费级“黑飞”无人机进行应急处置的无线电干扰设备，可在净空区域3km范围内定向使用干扰频段对无人机进行全时段、全天候、全方位、高精度干扰处置，强制无人机迫降或返航。',
              img: [require('@/views/pc/productImg/img22.png')]
            },
            {
              title: '无人机导航诱骗系统基站：',
              text: '导航诱导系统通过发射干扰信号，对“黑飞”无人机的卫星导航单元进行干扰，对试图接近的无人机实施有效驱离，也可使防护区域内的无人机无法起飞，达到管制“黑飞”无人机的目的。',
              img: [require('@/views/pc/productImg/img23.png')]
            },
            {
              title: '三频段便携式机动无人机反制设备：',
              text: '便携式无人机管控设备主要功能是通过对无人机飞控、图传信道和定位信号的阻塞与干扰，迫使无人机降落、悬停或返航。该产品可广泛应用于单位、基地、场站、看守所、核电站、化工厂及大型集会场所等各类禁止无人机出现的区域。',
              img: [require('@/views/pc/productImg/img24.png')]
            },
            {
              title: '重载云台多光谱摄像机：',
              text: '重载云台多光谱摄像机可昼夜完成对周边一定范围内的地面、水面目标进行搜索、观察、取证和跟踪，可用于边海防的监控和警戒。可昼夜完成对舰船周边一定海域内的海上和空中目标进行搜索、观察、取证和跟踪。',
              img: [require('@/views/pc/productImg/img25.png')]
            },
          ],
        },
        {
          name: '异构无人集群自主多域作战弹性指控平台产品',
          overview: '兆群是由湖南宸瀚科技有限公司基于轻量化联盟链技术自主研发的异构无人集群自主多域作战弹性指控平台，针对复杂环境下无人机集群侦察、协同、打击等场景，提出了多模传感信息融合、无人集群分布式协同控制和目标识别跟踪等技术，提高无人集群在城市、野外、岛屿等场景下的协同侦察、指挥控制、集群打击等能力，提升集群作战效能。平台结合区块链、人工智能、无人系统等前沿技术，构建了去中心化、自主化、自治化的体系架构，具备多样化、易拓展等特点，确保系统能够实现高效的互操作性。在协同OODA（感知-判断-决策-行动）中，优化了回路低延迟响应、行为决策效率等问题，提升了无人机集群在复杂环境中的协同效率和实时决策能力。<br\>兆群产品实现了全域态势感知、自主任务分配与动态路径规划功能，能够有效解决多平台异构通信兼容性差、复杂环境下任务执行滞后等痛点，对无人装备智能协同指控具有去中心化指挥、抗干扰容错作用，为无人作战体系作战效能提升以及全域联合作战、快速反应制胜提供有力支撑。',
          productIntroductionText: '异构无人集群自主多域作战弹性指控平台的软硬件组成图如下：',
          productIntroductionText2: '平台软件包括：载具侧无人集群异构多域飞控系统、载具侧极轻量化区块链高安全自组网通信系统、边缘计算系统、无人集群指挥所地面站高安全多对多通联系统、无人集群地面站侧单装级作战任务分配分发系统、无人集群指挥所侧作战资源调度管理系统、无人集群指挥所侧作战任务智能规划系统、无人集群指挥所侧集群级作战任务协同分配执行系统、无人集群指挥所侧智能情报分析及打击毁伤效果评估系统和载具侧多模吊舱载荷自适应控制及运用系统各一套；<br\>平台硬件包括：实体无人机、作战仿真计算终端、多维态势信息分发显示控制终端、智能边缘计算网桥、席位工作站、集群作战指控地面站、有线交换机、无线交换机、作战决策计算引擎、多维定位终端、战场态势多维可视化展示器和战场数据图传设备数量若干。',
          productIntroductionImg: [require('@/views/pc/productImg/img26.png')],
          productIntroduction: [],
        },
        {
          name: '保障仿真筹划管控运维系统产品',
          overview: '保障仿真筹划管控运维系统以维持装备正常运行的日常维护模拟训练为牵引，以受训人员保障作业以及施训人员导调控制为核心，构建基于模型驱动、态势导调的保障模拟训练环境。系统具备保障需求分析、保障方案拟制、运行维护管理、故障抢修应急响应等训练功能，以及案例分析、作业记录管理与回放、导调控制等组训功能。',
          overviewImg: [require('@/views/pc/productImg/img27.png')],
          productIntroduction: [
            {
              title: '保障仿真支撑工具：',
              text: '提供保障仿真运行平台，基于区块链的分布式运行平台以及与其他系统的互联接口，支撑底层资源调用和上层功能实现。',
              img: []
            },
            {
              title: '保障仿真模型库：',
              text: '保障仿真模型库主要包括保障仿真实体模型和指控业务模型等模块，提供保障相关人员、装备和保障行动等模拟功能。仿真模型采用动态库的形式，以动态加载的方式加入仿真推演。仿真模型的计算调度、时间控制、输入输出由仿真引擎控制完成。',
              img: []
            },
            {
              title: '保障资源筹划工具：',
              text: '提供保障任务分析、保障资源分析以及保障方案辅助生成等功能，支持开展保障组织筹划训练，并通过分布式共识在区块链中留存关键事件可信记录，主要包括保障任务分析、保障资源分析、保障方案生成等模块。该工具最终产生保障方案。',
              img: []
            },
            {
              title: '保障资源管控工具',
              text: '提供保障资源监控、管理、调配功能，支持保障态势监控、硬件设备调整、应用软件部署、数据加载和保障行动调控等资源管控训练，并通过分布式共识在区块链中留存关键事件哈希记录，主要包括保障态势监控、保障资源调配、保障行动调控等模块。在这里产生资源动态数据。',
              img: []
            },
            {
              title: '保障运行维护工具：',
              text: '提供保障运行监控、运维情况处置功能，支持开展保障运行异常监测、故障溯源分析、故障预测分析、匹配筛选处置、处置工单生成等保障运行维护训练，并通过分布式共识在区块链中留存关键事件哈希记录，主要包括保障异常监测、保障故障预测、保障情况处置等模块。',
              img: []
            },
            {
              title: '保障业务导调工具：',
              text: '导调功能包含接收作战演练和应用环境信息的大系统导调以及保障业务内部导调两类功能。<br/>' +
                  '大系统导调由保障业务系统定义导调命令格式，综合训练模拟系统、信息保障对抗推演系统等作战演练与应用环境依据该格式下发导调命令，保障业务系统接收后进行解析，完成相应的导调。<br/>' +
                  '保障业务内部导调按照下达训练科目、下发导调文书、跟踪训练情况、训练结果讲评等主要环节展开。',
              img: []
            },
          ],
        },
      ]
    }
  },
  watch: {
    $route:{
      immediate:true,
      handler(){
        this.getDataList()
      }
    }
  },
  created(){
    this.getDataList()
  },
  methods:{
    goabout(){
      this.$router.push({
        name: 'about'
      })
    },
    getDataList() {
      if(this.$route.query.text){
        console.log(this.$route.query.text,'----')
        this.navList = this.newsList.find(item => {
          return item.name === this.$route.query.text
        })
        console.log(this.navList,'----')

      } else {
        this.navList = this.newsList[0]
      }

    },
  },
}
</script>

<style scoped lang="scss">
.subView {
  margin-top: 78px;
  background-color: #fff;
  min-width: 1580px;
  width: 100%;
  .subView_list {

    .subView_item {
      background-image: url("../../assets/mtevidence/beijing.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 100%;
      height: 220px;
      text-align: center;

      .title {
        font-size: 37px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #282B31;
        padding-top: 50px;

        .text {
          font-size: 37px;
          font-weight: 300;
          color: #2D3036;
        }
      }

      .btnBox {
        margin-top: 32px;
      }

      .btn {
        width: 139px;
        height: 39px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 16px;
        background: #0069FD;
        border-radius: 20px;
        margin-top: 29px;
      }
    }
    .box-left{
      margin-left: 15%;
      width: 30%;
    }
    .box-right{
      margin-left: 10%;
      width: 80%;
      padding-bottom: 80px;
      min-height: 220px;
    }
    .subView_top{
      text-align: left;
      width: 70%;
      margin-left: 20%;
      .top-title {
        padding-top: 32px;

        .title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 700;
          color: #282F3C;
          margin-left: 9px;
        }

        .border {
          width: 27px;
          height: 3px;
          margin-top: 3px;
          background-color: #056DFF;
        }
      }
      .font-p p{
        /*min-width: 1010px;*/
        height: 63px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #353F52;
        /*line-height: 80px;*/
        margin-top: 21px;
      }
    }
    .subView_center{
      text-align: left;
      width: 60%;
      margin-left: 20%;
      .top-title {
        padding-top: 82px;
        .title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #282F3C;
          margin-left: 4px;
        }

        .border {
          width: 27px;
          height: 3px;
          margin-top: 3px;
          background-color: #056DFF;
        }
      }
      .list {
        display: flex;
        width: 100%;
        .item {
          /* margin-right: 6%; */
          flex: 1;

          &:last-child {
            margin-right: 0;
          }

          .item_img {
            padding: 20px;
            margin-top: 61px;
          }

          .item_img img {
            /*width: 106px;*/
            /*height: 106px;*/
          }
          .item_name {
            text-align: center;
            font-size: 24px;
            color: #2A67E3;
            padding: 20px 0px;
            height: 102px;
          }
          .item_text {
            width: 84px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #282F3C;
            line-height: 20px;
            text-align: center;
            margin-left: 10px;
          }
        }
      }

    }
    .subView_foot{
      text-align: left;
      width: 60%;
      margin-left: 20%;
      .top-title {
        padding-top: 82px;

        .title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #282F3C;
          margin-left: 4px;
        }

        .border {
          width: 27px;
          height: 3px;
          margin-top: 3px;
          background-color: #056DFF;
        }
      }
      img{
        width: 100%;
        height: 127px;
        background: #FAFBFC;
        border-radius: 5px;
        margin-top: 84px;
        margin-bottom: 89px;
      }
    }
  }
}
</style>
